import { useEffect } from 'react';

import { parseUrlParams } from 'web-shared/utils/url-params';
import { getBaseRedirectUrl } from 'web-shared/utils/base-url';

const SSOSignOutCallbackPage = () => {
  useEffect(() => {
    const params = parseUrlParams<{ state?: string }>(window.location.search);

    if (params.state) {
      window.location.replace(`https://${params.state}.over-haul.com/app/sign-in`);
    } else {
      window.location.replace(`${getBaseRedirectUrl()}/app/sign-in`);
    }
  }, []);

  return null;
};

export default SSOSignOutCallbackPage;
